import firebase from 'firebase/app'
require('@firebase/auth');
require('@firebase/firestore');
require('@firebase/functions');
require('@firebase/messaging');
import Vue from 'vue'
import Router from 'vue-router'
import Investments from './views/Investments.vue'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import SignUp from './views/SignUp.vue'
import Financials from './views/Financials.vue'
import Goalspage from './views/Goalspage.vue'
import Transactions from './views/Transactions.vue'
import Info from './views/Info.vue'
import EditContactinfo from './views/EditContactinfo.vue'
import Vault from './views/Vault.vue'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/login'
    },
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/sign-up',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/financials',
      name: 'financials',
      component: Financials,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/info',
      name: 'info',
      component: Info,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/info/:contact_id',
      name: 'edit-contact',
      component: EditContactinfo,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/vault',
      name: 'vault',
      component: Vault,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/investments',
      name: 'investments',
      component: Investments,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/transactions',
      name: 'transactions',
      component: Transactions,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/goals',
      name: 'goalspage',
      component: Goalspage,
      meta: {
        requiresAuth: true
      }
    }
  ]
});

router.beforeEach((to, from, next) =>{
const currentUser = firebase.auth().currentUser;
const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

if (requiresAuth && !currentUser) next('login');
else if (!requiresAuth && currentUser) next('home');
else next();

});

export default router;